import React, { useEffect, useState, useCallback } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import { validationRule } from "../../utils/constant";
import { commonService } from "../../utils/commonService";
import { checkValidation } from "../../utils/helper";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import Loader from "../Loader/Loader";


const TwoFactorSetting = ({ showModal, closeModal }) => {
    const userDetail = commonService.getLoginUserData();

    const [TwoFAAuthTypeTerm, setTwoFAAuthTypeTerm] = useState("");
    const [appSetup, setAppSetup] = useState(null);
    const [appCode, setAppCode] = useState("");
    const [appLoading, setAppLoading] = useState(false);

    let validationObj = {
        authtypeterm: "",
        authtoken: "",
        validationRule: [
            {
                fieldName: "authtypeterm",
                rule: validationRule.required,
                message: "Authentication Type is required",
            }
        ],
        errorObj: {},
        isValidate: true,
    };

    const [userData, setUserData] = useState(validationObj);
    const [GetDataLoading, setGetDataLoading] = useState(false);
    const getAllDetailsById = async () => {
        setGetDataLoading(true)
        let allDetailsByIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.UserManagement +
                    API_URL.USER.GET_ALL_DETAILS_BY_ID,
                body: {
                    id: userDetail?.userid,
                },
            },
            false
        );

        let response = apiResponse(false, allDetailsByIdResponse);

        if (response?.isValidate) {
            if (response?.data?.data?.user?.authtypeterm) {
                if (response?.data?.data?.user?.authtypeterm === "Email Code") {
                    validationObj.validationRule.push({
                        fieldName: "authtoken",
                        rule: validationRule.required,
                        message: "Authentication email is required",
                    });

                    validationObj.validationRule.push({
                        fieldName: "authtoken",
                        rule: validationRule.email,
                        message: "Enter valid email",
                    });
                }
            }
            setTwoFAAuthTypeTerm(response?.data?.data?.user?.authtypeterm ? response?.data?.data?.user?.authtypeterm : "");
            setUserData({
                ...userData,
                authtypeterm: response?.data?.data?.user?.authtypeterm ? response?.data?.data?.user?.authtypeterm : "",
                authtoken: response?.data?.data?.user?.authtoken ? response?.data?.data?.user?.authtoken : "",
                validationRule: validationObj.validationRule
            });
        }
        setGetDataLoading(false)
    };

    useEffect(() => {
        if (userDetail && userDetail?.userid) {
            getAllDetailsById();
        }
    }, []);

    const [SendOTPLoading, setSendOTPLoading] = useState(false);
    const [IsOTPSend, setIsOTPSend] = useState(false);
    const SendOTPOnAuthTokenEmail = async () => {
        setSendOTPLoading(true);

        let validation = checkValidation(userData);

        if (!validation.isValidate) {
            setUserData(validation);
            setSendOTPLoading(false);
            return;
        }

        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.TOWFAEMAILVERIFICATION,
                body: {
                    userid: userDetail?.userid,
                    authtoken: userData.authtoken
                },
            },
            true
        );

        let response = apiResponse(true, saveResponse, setSendOTPLoading);

        if (response?.isValidate) {
            setIsOTPSend(true);
        }
    };


    let validationEmail2FAOTPObj = {
        otp: "",
        validationRule: [
            {
                fieldName: "otp",
                rule: validationRule.required,
                message: "OTP is required",
            }
        ],
        errorObj: {},
        isValidate: true,
    };
    const [Email2FAOTPData, setEmail2FAOTPData] = useState(validationEmail2FAOTPObj);

    const [VerifyOTPLoading, setVerifyOTPLoading] = useState(false);
    const VerifyAuthTokenEmailOTP = async () => {
        setVerifyOTPLoading(true);

        let validation = checkValidation(Email2FAOTPData);

        if (!validation.isValidate) {
            setEmail2FAOTPData(validation);
            setVerifyOTPLoading(false);
            return;
        }

        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.TOWFAEMAILOTPVERIFICATION,
                body: {
                    userid: userDetail?.userid,
                    authtoken: userData.authtoken,
                    otp: Email2FAOTPData.otp
                },
            },
            true
        );

        let response = apiResponse(true, saveResponse, setVerifyOTPLoading);

        if (response?.isValidate) {
            setTwoFAAuthTypeTerm("Email Code");
            setIsOTPSend(false);
            closeModal();
        }
    };

    const StartAuthenticatorSetup = async () => {
        setAppLoading(true);
        const result = await apiCall({
            method: "POST",
            url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.TOWFAAPPSETUP,
            body: { userid: userDetail?.userid },
        }, true);
        const response = apiResponse(true, result, setAppLoading);
        if (response?.isValidate) {
            setAppSetup(response.data.data);
            setAppCode("");
        }
    };

    const VerifyAuthenticatorSetup = async () => {
        if (!/^\d{6}$/.test(appCode) || !appSetup) return;
        setAppLoading(true);
        const result = await apiCall({
            method: "POST",
            url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.TOWFAAPPVERIFICATION,
            body: { userid: userDetail?.userid, secret: appSetup.secret, otp: appCode },
        }, true);
        const response = apiResponse(true, result, setAppLoading);
        if (response?.isValidate) {
            setTwoFAAuthTypeTerm("Authenticator App");
            setAppSetup(null);
            closeModal();
        }
    };


    const [RemoveTwoFALoading, setRemoveTwoFALoading] = useState(false);
    const [IsRemoveTwoFAOTPSend, setIsRemoveTwoFAOTPSend] = useState(false);
    const RemoveTwoFA = async () => {
        if (TwoFAAuthTypeTerm === "Authenticator App") {
            setIsRemoveTwoFAOTPSend(true);
            return;
        }
        setRemoveTwoFALoading(true);

        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.REMOVETWOFA,
                body: {
                    userid: userDetail?.userid
                },
            },
            true
        );
        let response = apiResponse(true, saveResponse, setRemoveTwoFALoading);
        if (response?.isValidate) {
            setIsRemoveTwoFAOTPSend(true)
        }
    };

    let validationRemoveTwoFAObj = {
        otp: "",
        validationRule: [
            {
                fieldName: "otp",
                rule: validationRule.required,
                message: "OTP is required",
            }
        ],
        errorObj: {},
        isValidate: true,
    };

    const [RemoveTwoFAData, setRemoveTwoFAData] = useState(validationRemoveTwoFAObj);
    const [VerifyRemoveTwoFALoading, setVerifyRemoveTwoFALoading] = useState(false);

    const VerifyRemoveTwoFA = async () => {
        setVerifyRemoveTwoFALoading(true);

        let validation = checkValidation(RemoveTwoFAData);

        if (!validation.isValidate) {
            setRemoveTwoFAData(validation);
            setVerifyRemoveTwoFALoading(false);
            return;
        }

        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.UserManagement + API_URL.USER.VERIFYREMOVETWOFA,
                body: {
                    userid: userDetail?.userid,
                    otp: RemoveTwoFAData.otp
                },
            },
            true
        );

        let response = apiResponse(true, saveResponse, setVerifyRemoveTwoFALoading);

        if (response?.isValidate) {
            setTwoFAAuthTypeTerm("");
            setUserData(validationObj);
            setIsRemoveTwoFAOTPSend(false);
            setRemoveTwoFAData(validationRemoveTwoFAObj);
            closeModal();
        }
    };

    return (
        <>
            <Modal className="userManagementModalMain" centered show={showModal} onHide={closeModal} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Two-Factor Authentication
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        GetDataLoading ?
                            <> <Loader /></>
                            :
                            <>
                                {
                                    TwoFAAuthTypeTerm ?
                                        <>
                                            <div class="security-card">
                                                <div class="status-box">

                                                    <div class="status-title">
                                                        2FA is enabled
                                                    </div>

                                                    <p class="status-description">
                                                        Your account is protected with Two-Factor Authentication.
                                                        You'll need to enter a verification code when you sign in.
                                                    </p>
                                                </div>
                                                <div class="details">

                                                    <div class="detail-row">
                                                        <span class="label">Status</span>
                                                        <span class="value active">Active</span>
                                                    </div>

                                                    <div class="detail-row">
                                                        <span class="label">Method</span>
                                                        <span class="value">{userData.authtypeterm}</span>
                                                    </div>

                                                </div>
                                                <Col xl={12} className="text-center">
                                                    {
                                                        RemoveTwoFALoading ? (
                                                            <button className="default-btn primary-btn" type="button" disabled>
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                Loading...
                                                            </button>
                                                        ) : (
                                                            <button id={commonService.generateGlobalClickTrackerID("UserManagementModal", "submit", "")} className="default-btn primary-btn" onClick={() => { RemoveTwoFA(); }}>
                                                                Disable 2FA
                                                            </button>
                                                        )
                                                    }
                                                </Col>
                                                {
                                                    IsRemoveTwoFAOTPSend &&
                                                    <>
                                                        <Col xl={12}>
                                                            <div className="from-groups no-border-break mb-3">
                                                                <Form.Label>{TwoFAAuthTypeTerm === "Authenticator App" ? "Authenticator App Code" : "Enter Verification OTP"}</Form.Label>
                                                                <Form.Control id={commonService.generateGlobalClickTrackerID("UserProfileUpdateModal", "authtoken", "")}
                                                                    type="text"
                                                                    inputMode={TwoFAAuthTypeTerm === "Authenticator App" ? "numeric" : "text"}
                                                                    maxLength="6"
                                                                    placeholder={TwoFAAuthTypeTerm === "Authenticator App" ? "Enter app code" : "Enter Verification OTP"}
                                                                    value={RemoveTwoFAData?.otp}
                                                                    onChange={(e) =>
                                                                        setRemoveTwoFAData({
                                                                            ...RemoveTwoFAData,
                                                                            otp: TwoFAAuthTypeTerm === "Authenticator App" ? e.target.value.replace(/\D/g, "") : e.target.value,
                                                                        })
                                                                    }

                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter" && e.target.value.length === 6) {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            VerifyRemoveTwoFA();
                                                                        }
                                                                    }}
                                                                />
                                                                {RemoveTwoFAData?.errorObj?.otp && (
                                                                    <small className="text-danger">
                                                                        {RemoveTwoFAData?.errorObj?.otp}
                                                                    </small>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xl={12} className="text-center">
                                                            {
                                                                VerifyRemoveTwoFALoading ? (
                                                                    <button className="default-btn primary-btn" type="button" disabled>
                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        Loading...
                                                                    </button>
                                                                ) : (
                                                                    <button id={commonService.generateGlobalClickTrackerID("UserManagementModal", "submit", "")} className="default-btn primary-btn" disabled={TwoFAAuthTypeTerm === "Authenticator App" && RemoveTwoFAData.otp.length !== 6} onClick={() => { VerifyRemoveTwoFA(); }}>
                                                                        Verify OTP
                                                                    </button>
                                                                )
                                                            }
                                                        </Col>
                                                    </>
                                                }

                                            </div>
                                        </>
                                        :
                                        <Row>
                                            <Col xl={12}>
                                                <div className="from-groups no-border-break mb-3">
                                                    <Form.Label>Authentication Type</Form.Label>
                                                    <Form.Select id={commonService.generateGlobalClickTrackerID("UserProfileUpdateModal", "auth-type", "")}
                                                        aria-label="Default select example"
                                                        value={userData?.authtypeterm}
                                                        onChange={(e) => {
                                                            if (e.target.value) {
                                                                if (e.target.value === "Email Code") {
                                                                    validationObj.validationRule.push({
                                                                        fieldName: "authtoken",
                                                                        rule: validationRule.required,
                                                                        message: "Authentication email is required",
                                                                    });

                                                                    validationObj.validationRule.push({
                                                                        fieldName: "authtoken",
                                                                        rule: validationRule.email,
                                                                        message: "Enter valid email",
                                                                    });
                                                                }
                                                            }

                                                            setAppSetup(null);
                                                            setAppCode("");
                                                            setIsOTPSend(false);
                                                            setUserData({
                                                                ...userData,
                                                                authtypeterm: e.target.value,
                                                                authtoken: "",
                                                                errorObj: {},
                                                                validationRule: validationObj.validationRule
                                                            });


                                                        }}
                                                    >
                                                        <option value="">Select Auth Type</option>
                                                        {/*<option value="Email Code">Email Code</option>*/}
                                                        <option value="Authenticator App">Authenticator App</option>
                                                    </Form.Select>
                                                    {userData?.errorObj?.authtypeterm && (
                                                        <small className="text-danger">
                                                            {userData?.errorObj?.authtypeterm}
                                                        </small>
                                                    )}
                                                </div>
                                            </Col>
                                            {
                                                userData?.authtypeterm === "Email Code" &&
                                                <>

                                                    <Col xl={12}>
                                                        <div className="from-groups no-border-break mb-3">
                                                            <Form.Label>Authentication Email</Form.Label>
                                                            <Form.Control id={commonService.generateGlobalClickTrackerID("UserProfileUpdateModal", "authtoken", "")}
                                                                type="text"
                                                                maxLength="167"
                                                                placeholder="Enter Authentication Email"
                                                                value={userData?.authtoken}
                                                                onChange={(e) =>
                                                                    setUserData({
                                                                        ...userData,
                                                                        authtoken: e.target.value,
                                                                    })
                                                                }
                                                            />
                                                            {userData?.errorObj?.authtoken && (
                                                                <small className="text-danger">
                                                                    {userData?.errorObj?.authtoken}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col xl={12} className="text-center">
                                                        {
                                                            SendOTPLoading ? (
                                                                <button className="default-btn primary-btn" type="button" disabled>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    Loading...
                                                                </button>
                                                            ) : (
                                                                <button id={commonService.generateGlobalClickTrackerID("UserManagementModal", "submit", "")} className="default-btn primary-btn" onClick={() => { SendOTPOnAuthTokenEmail(); }}>
                                                                    Verify Email
                                                                </button>
                                                            )
                                                        }
                                                    </Col>
                                                    {
                                                        IsOTPSend &&
                                                        <>
                                                            <Col xl={12}>
                                                                <div className="from-groups no-border-break mb-3">
                                                                    <Form.Label>Enter Verification OTP</Form.Label>
                                                                    <Form.Control id={commonService.generateGlobalClickTrackerID("UserProfileUpdateModal", "authtoken", "")}
                                                                        type="text"
                                                                        maxLength="6"
                                                                        placeholder="Enter Verification OTP"
                                                                        value={Email2FAOTPData?.otp}
                                                                        onChange={(e) =>
                                                                            setEmail2FAOTPData({
                                                                                ...Email2FAOTPData,
                                                                                otp: e.target.value,
                                                                            })
                                                                        }

                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "Enter" && e.target.value.length === 6) {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                VerifyAuthTokenEmailOTP();
                                                                            }
                                                                        }}
                                                                    />
                                                                    {Email2FAOTPData?.errorObj?.otp && (
                                                                        <small className="text-danger">
                                                                            {Email2FAOTPData?.errorObj?.otp}
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            </Col>
                                                            <Col xl={12} className="text-center">
                                                                {
                                                                    VerifyOTPLoading ? (
                                                                        <button className="default-btn primary-btn" type="button" disabled>
                                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                            Loading...
                                                                        </button>
                                                                    ) : (
                                                                        <button id={commonService.generateGlobalClickTrackerID("UserManagementModal", "submit", "")} className="default-btn primary-btn" onClick={() => { VerifyAuthTokenEmailOTP(); }}>
                                                                            Verify OTP
                                                                        </button>
                                                                    )
                                                                }
                                                            </Col>
                                                        </>
                                                    }
                                                </>
                                            }
                                            {userData?.authtypeterm === "Authenticator App" &&
                                                <Col xl={12} className="text-center">
                                                    {!appSetup ? (
                                                        <button type="button" className="default-btn primary-btn" disabled={appLoading} onClick={StartAuthenticatorSetup}>
                                                            {appLoading ? "Loading..." : "Set up Authenticator App"}
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <QRCodeSVG value={appSetup.uri} size={180} includeMargin title="Authenticator App setup QR code" />
                                                            <div className="from-groups no-border-break my-3">
                                                                <Form.Label>Setup key</Form.Label>
                                                                <Form.Control type="text" readOnly value={appSetup.secret} aria-label="Authenticator setup key" />
                                                            </div>
                                                            <div className="from-groups no-border-break mb-3">
                                                                <Form.Label>Authenticator App Code</Form.Label>
                                                                <Form.Control type="text" inputMode="numeric" autoComplete="one-time-code" maxLength="6"
                                                                    value={appCode} placeholder="Enter app code"
                                                                    onChange={(event) => setAppCode(event.target.value.replace(/\D/g, ""))}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter" && e.target.value.length === 6) {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            VerifyAuthenticatorSetup();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <button type="button" className="default-btn primary-btn" disabled={appLoading || appCode.length !== 6} onClick={VerifyAuthenticatorSetup}>
                                                                {appLoading ? "Loading..." : "Enable 2FA"}
                                                            </button>
                                                        </>
                                                    )}
                                                </Col>
                                            }
                                        </Row>
                                }
                            </>

                    }

                </Modal.Body>
            </Modal>
        </>
    );
};

export default TwoFactorSetting;
